var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECF4FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5775_23651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9167 16.9167V15.6667M30.1995 17.8005L31.0834 16.9167M31.0919 21.0833H32.3419M32.2922 24.8333C31.8741 29.0444 28.3211 32.3333 24 32.3333C19.3976 32.3333 15.6667 28.6024 15.6667 24C15.6667 19.6789 18.9556 16.1259 23.1667 15.7078M24 20.6667H27.3334V24M27.0164 20.6667C25.0545 23.4397 21.822 25.25 18.1667 25.25C17.3309 25.25 16.5173 25.1554 15.7359 24.9762",
    stroke: "#126DD8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5775_23651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalGoals);
export default __webpack_public_path__ + "static/media/total-goals.cdeaed28a6425265da7a8e3434ae129e.svg";
export { ForwardRef as ReactComponent };